<template>
  <pt-detection-detail class="pt-detection-detail__withData"></pt-detection-detail>
</template>

<script>
import PtDetectionDetail from './index'
export default {
  name: 'pt-detection-detail__withData',
  components: {
    'pt-detection-detail': PtDetectionDetail
  }
}
</script>
